import React from "react";

interface NeumorphicContainerProps {
  children: React.ReactNode;
  className?: string;
  borderRadius?: number; // In pixels
  style?: React.CSSProperties; // Optional style object
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const NeumorphicContainer: React.FC<NeumorphicContainerProps> = ({
  children,
  className,
  borderRadius,
  style: passedStyle, // Rename the destructured 'style' prop to 'passedStyle'
  onClick,
}) => {
  const internalStyle: React.CSSProperties = {
    "--neu-container-border-radius": borderRadius
      ? `${borderRadius}px`
      : undefined,
  } as React.CSSProperties;

  const combinedStyle: React.CSSProperties = {
    ...internalStyle,
    ...passedStyle,
  };

  return (
    <div
      className={`neumorphic-container ${className || ""}`}
      style={combinedStyle}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
